function userReducer(state, action) {
  // console.log(action.user[0])

  switch (action.type) {
    case "init":
      if (action.user) {
        localStorage.setItem("humphree-user", JSON.stringify(action.user[0]))
        return action.user[0]
      }
      return []
    case "reset":
      localStorage.setItem("humphree-user", JSON.stringify([]))
      return []
    default:
      return state
  }
}

export default userReducer
